export const cardHolderNameCharactersPattern = /^[A-Za-z\s'-]+$/;
export const cardHolderFullNamePattern = /^[A-Za-z'-]+(?:\s+[A-Za-z'-]+)+$/;
